import { render, staticRenderFns } from "./404.vue?vue&type=template&id=95d9c2a4"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d9c2a4')) {
      api.createRecord('95d9c2a4', component.options)
    } else {
      api.reload('95d9c2a4', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=95d9c2a4", function () {
      api.rerender('95d9c2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/404.vue"
export default component.exports